import { DOCUMENT_BLOCK_TYPES, DOCUMENT_ALIGN } from "./schema";

const contratoLocacaoImovel = {
  id: "contrato-locacao-imovel",
  label: "Contrato de Locacao de Imovel",
  blocks: [
    {
      type: DOCUMENT_BLOCK_TYPES.TITLE,
      content: "CONTRATO DE LOCACAO DE IMOVEL",
      align: DOCUMENT_ALIGN.LEFT,
    },
    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 3 },
    { type: DOCUMENT_BLOCK_TYPES.TITLE, content: "LOCADOR(ES)" },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{LOCADORES}",
      contentFormat: "html",
    },
    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },
    { type: DOCUMENT_BLOCK_TYPES.TITLE, content: "LOCATARIO(S)" },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{LOCATARIOS}",
      contentFormat: "html",
    },
    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },
    { type: DOCUMENT_BLOCK_TYPES.TITLE, content: "FIADOR" },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{FIADORES}",
      contentFormat: "html",
    },
    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 2 },
    { type: DOCUMENT_BLOCK_TYPES.TITLE, content: "CLAUSULAS E CONDICOES" },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "1) IMOVEL",
      align: DOCUMENT_ALIGN.LEFT,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "1.1) {TIPO_IMOVEL}",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "1.2) O imovel, entregue na data da assinatura deste contrato pelo LOCADOR ao LOCATARIO, possui as caracteristicas, aceito expressamente pelas partes.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "2) UTILIZACAO DO IMOVEL",
      align: DOCUMENT_ALIGN.LEFT,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "2.1) Esta LOCACAO destina-se exclusivamente ao uso {USO_LOCACAO} do imovel, sendo vedado ao LOCATARIO subloca-lo ou utiliza-lo de forma diversa, salvo autorizacao expressa do LOCADOR.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "3) CONDICOES DO IMOVEL",
      align: DOCUMENT_ALIGN.LEFT,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "3) O imovel e entregue ao LOCATARIO nas condicoes em que se encontra, conforme vistoriado previamente pelo LOCATARIO ou, quando existente, conforme descrito em Auto de Vistoria, comprometendo-se este a mante-lo em bom estado de conservacao e a devolve-lo, ao termino da locacao, nas mesmas condicoes em que o recebeu, ressalvado o desgaste natural decorrente do uso normal, com todos os tributos, encargos e demais obrigacoes devidamente quitadas.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "4) BENFEITORIAS E CONSTRUCAO",
      align: DOCUMENT_ALIGN.LEFT,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "4.1) Qualquer benfeitoria ou construcao no imovel dependera de autorizacao expressa do LOCADOR, cabendo ao LOCATARIO desfaze-la, caso nao seja aceita, e devolver o imovel como entregue.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "4.2) As benfeitorias, consertos ou reparos integrarao o imovel, sem direito do LOCATARIO a retencao ou indenizacao.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "5) DEVOLUCAO DO IMOVEL",
      align: DOCUMENT_ALIGN.LEFT,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "5.1) O LOCATARIO devolvera o imovel nas mesmas condicoes em que o recebeu.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "5.2) O imovel e suas instalacoes deverao estar em perfeitas condicoes de funcionamento, exceto por desgastes naturais decorrentes do uso regular do imovel.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "6) CONDOMINIO",
      align: DOCUMENT_ALIGN.LEFT,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "6.1) O LOCATARIO declara estar ciente de que, em caso de locacao de imovel em edificio com condominio, ficara obrigado a cumprir todas as clausulas estabelecidas na Convencao Condominial e no Regulamento Interno vigentes.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "7) DIREITO DE PREFERENCIA E VISTORIAS",
      align: DOCUMENT_ALIGN.LEFT,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "7.1) Caso o LOCADOR manifeste a intencao de vender o imovel descrito neste contrato, devera notificar o LOCATARIO por escrito, que tera o prazo de 30 (trinta) dias para se manifestar a partir da comunicacao recebida.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "7.2) O LOCATARIO permitira ao LOCADOR realizar vistorias no imovel, em dia e hora a serem previamente combinados, com o objetivo de averiguar o estado de conservacao e o funcionamento de todas as instalacoes e acessorios.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "7.3) Constatado vicio que comprometa a estrutura fisica do imovel, o LOCATARIO devera providenciar o imediato conserto. O nao saneamento do problema autoriza o LOCADOR a rescindir o contrato, sem prejuizo das penalidades previstas neste instrumento.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "7.4) Caso o LOCATARIO nao se manifeste no prazo estipulado no caput desta clausula, ficara permitido ao LOCADOR realizar vistorias no imovel acompanhado de possiveis interessados.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "8) ATOS DE INFORMACAO ENTRE OS CONTRATANTES",
      align: DOCUMENT_ALIGN.LEFT,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "8.1) As partes acordam comunicar-se exclusivamente por escrito, utilizando meios legalmente admitidos.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "9) VALOR DO ALUGUEL, DESPESAS, E REAJUSTES",
      align: DOCUMENT_ALIGN.LEFT,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "9.1) A titulo de aluguel mensal, o LOCATARIO obriga-se a pagar o valor de R$ {VALOR_ALUGUEL}, com vencimento todo dia {DATA_PAGAMENTO}.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "9.2) O aluguel e devido de forma mensal, sucessiva e antecipada, correspondendo cada pagamento ao periodo de uso do imovel no mes subsequente, obrigando-se o LOCATARIO a efetuar o pagamento independentemente de aviso ou cobranca.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "9.3) O valor do aluguel sera reajustado anualmente, tendo como base os indices previstos e acumulados no periodo anual do indice aplicavel.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "9.4) Faculta ao LOCADOR, ou a seu procurador, a cobranca do(s) aluguel(eis), tributo(s) e despesa(s) vencido(s) oriundo(s) deste contrato, podendo utilizar-se de todos os meios legais permitidos para tal fim, inclusive judicialmente, se necessario.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "9.5) Ficarao a cargo do LOCATARIO, exceto no que diz respeito a contribuicao de melhoria, todas as despesas relacionadas a manutencao e uso do imovel, incluindo consumo de agua, energia eletrica, gas, taxas ordinarias de condominio, limpeza e conservacao.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "9.6) Caso o LOCATARIO nao realize o pagamento do aluguel ate a data prevista em contrato, ficara sujeito ao pagamento de uma multa equivalente a {MULTA_ATRASO} % sobre o valor do aluguel ajustado neste contrato, acrescida de juros de mora de 1% ao mes e atualizacao monetaria.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "9.7) No caso de atraso no pagamento dos alugueis, o LOCATARIO sera considerado em mora, respondendo por todas as obrigacoes decorrentes do atraso, incluindo multa, juros de mora e atualizacao monetaria.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "9.8) Atos de mera tolerancia quanto ao atraso no pagamento do aluguel ou de outros tributos nao serao considerados como novacao ou alteracao das clausulas deste contrato.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "10) TOLERANCIA",
      align: DOCUMENT_ALIGN.LEFT,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "10.1) O LOCATARIO tera um prazo de tolerancia para realizar o pagamento do aluguel ate o segundo dia util apos o vencimento. Caso essa data nao seja um dia util, o pagamento devera ser efetuado no primeiro dia util seguinte.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "11) MULTA",
      align: DOCUMENT_ALIGN.LEFT,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "11.1) As partes concordam com a aplicacao de multa equivalente a {MULTA_INFRACAO} alugueis vigentes a epoca do ocorrido.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "11.2) Se o LOCATARIO devolver o imovel antes do termino do contrato, devera pagar uma multa correspondente a R$ {MULTA_RESCISAO_ANTECIPADA}.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "12) RESCISAO CONTRATUAL",
      align: DOCUMENT_ALIGN.LEFT,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "12.1) A rescisao ocorrera automaticamente, sem a necessidade de comunicacao previa ou indenizacao por parte do LOCADOR, nas situacoes previstas neste instrumento.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "12.2) A rescisao ocorrera tambem no caso de qualquer sinistro, incendio ou evento que torne impossivel a posse do imovel, independentemente de dolo ou culpa do LOCATARIO.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "12.3) A rescisao ocorrera tambem em caso de desapropriacao do imovel alugado.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "12.4) Se o imovel for utilizado para fins diferentes da locacao residencial, o LOCADOR tera o direito de rescindir imediatamente o contrato, sem que isso gere direito a indenizacao.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "13) PRAZO DA LOCACAO",
      align: DOCUMENT_ALIGN.LEFT,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "13.1) A locacao tera validade de {PRAZO_LOCACAO} mes(es).",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "13.2) Caso o contrato ultrapasse a data estabelecida, tornando-se por tempo indeterminado, o LOCADOR podera rescindi-lo mediante notificacao por escrito, com desocupacao em {DIAS_DESOCUPAR} dias.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "13.3) Na hipotese de prorrogacao, o LOCATARIO e o LOCADOR permanecerao obrigados a cumprir todas as disposicoes deste contrato.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "14) CLAUSULA DE GARANTIA",
      align: DOCUMENT_ALIGN.LEFT,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{CLAUSULA_GARANTIA}",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "15) DISPOSICOES GERAIS",
      align: DOCUMENT_ALIGN.LEFT,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "15.1) Os herdeiros, sucessores ou cessionarios das partes contratantes concordam desde ja em cumprir integralmente as disposicoes deste contrato.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "15.2) O eventual nao exercicio, por qualquer das partes, de direitos previstos neste contrato, nao sera considerado como renuncia, novacao ou alteracao contratual, podendo ser exigido a qualquer tempo.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "15.3) As partes reconhecem como validas as comunicacoes realizadas por meios eletronicos, incluindo e-mail e aplicativos de mensagens, desde que possibilitem a comprovacao de envio e recebimento.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "15.4) A eventual nulidade de qualquer clausula nao prejudicara as demais disposicoes deste contrato, que permanecerao validas e eficazes.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "16) FORO",
      align: DOCUMENT_ALIGN.LEFT,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "16.1) Este CONTRATO entra em vigor a partir da sua assinatura, com as partes elegendo o foro da cidade onde o imovel esta localizado, para resolver quaisquer questoes decorrentes da sua execucao e cumprimento.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },
    {
      type: DOCUMENT_BLOCK_TYPES.TITLE,
      content: "ENCERRAMENTO",
      align: DOCUMENT_ALIGN.LEFT,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "POR ESTAREM DE ACORDO, assinam o presente contrato.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{CIDADE_ASSINATURA}, {DATA_ASSINATURA}.",
      align: DOCUMENT_ALIGN.RIGHT,
    },
    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 2 },
    { type: DOCUMENT_BLOCK_TYPES.TITLE, content: "LOCADOR(ES)" },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{ASSINATURA_LOCADOR}",
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{ASSINATURA_CONJUGE_LOCADOR}",
      contentFormat: "html",
    },
    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },
    { type: DOCUMENT_BLOCK_TYPES.TITLE, content: "LOCATARIO(S)" },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{ASSINATURA_LOCATARIO}",
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{ASSINATURA_CONJUGE_LOCATARIO}",
      contentFormat: "html",
    },
    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },
    { type: DOCUMENT_BLOCK_TYPES.TITLE, content: "FIADOR" },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{ASSINATURA_FIADOR}",
    },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{ASSINATURA_CONJUGE_FIADOR}",
      contentFormat: "html",
    },
    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },
    { type: DOCUMENT_BLOCK_TYPES.TITLE, content: "TESTEMUNHAS" },
    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{ASSINATURA_TESTEMUNHA}",
    },
  ],
};

export default contratoLocacaoImovel;
